import React from "react";
import MileStoneRosterAssociation from "components/MileStones/MileStoneRosterAssociation";
import { Grid } from "@mui/material";
import classes from "./MileStones.module.css";
import applicationUsageLog from "../../utils/applicationUsagesLog";
import { Card, CardContent, Typography } from "@mui/material";

export default function MileStones() {
  React.useEffect(() => {
    applicationUsageLog(
      localStorage.getItem("User"),
      localStorage.getItem("EmailId"),
      "ASTT",
      "Milestones"
    );
  }, []);
  return (
    <div className={classes.mainContainer}>
      <Card
        sx={{
          height: "calc(100vh - 100px)",
          overflowY: "auto",
        }}
      >
        <CardContent>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              className={classes.rosterHeading}
              sx={{
                fontSize: "32px",
                fontFamily: "Urbanist, sans-serif",
                color: "#3F5765",
                fontWeight: "bold",
              }}
            >
              Class Milestones
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <MileStoneRosterAssociation></MileStoneRosterAssociation>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}
